import * as types from './types';

export const checkSamlAuthRequest = (data) => ({ type: types.CHECK_SAML_AUTH_REQUEST, data });
export const checkSamlAuthRequestFailure = (error) => ({ type: types.CHECK_SAML_AUTH_REQUEST_FAILURE, error });
export const checkSamlAuthRequestSuccess = (data) => ({ type: types.CHECK_SAML_AUTH_REQUEST_SUCCESS, data });
